
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"},style,staticStyle],
              attrs: Object.assign({"width":"16.555","height":"16.555","viewBox":"0 0 17 17","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","xml:space":"preserve","xmlns:serif":"http://www.serif.com/","style":"fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(1,0,0,1,-0.004,-0.001)"}},[_c('g',{attrs:{"id":"WKND-icon","transform":"matrix(1,8.88178e-16,-8.88178e-16,1,0.004,0.001)"}},[_c('g',{attrs:{"id":"background","transform":"matrix(1,0,0,1,0.277,0.277)"}},[_c('rect',{staticStyle:{"fill":"none"},attrs:{"x":"0","y":"0","width":"16","height":"16"}})]),_c('g',{attrs:{"transform":"matrix(1,0,0,1,-84,-6479)"}},[_c('g',{attrs:{"id":"Dribbble-Light-Preview"}},[_c('g',{attrs:{"id":"icons"}},[_c('path',{staticStyle:{},attrs:{"id":"arrow_left-_350_","d":"M92.277,6495.55L93.465,6494.4L87.165,6488.1L100.551,6488.1L100.551,6486.44L87.169,6486.44L93.448,6480.17L92.277,6479L84,6487.28L92.277,6495.55"}})])])])])])])
          )
        }
      }
    